import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import ModalBox from '../../../shared/modal';
import {reduxForm, Field} from 'redux-form';
import InputField from '../../../shared/form-elements/input';

const Form = props => {
	const {
		autotrashDataToResend, resendAutotrashConversion, handleSubmit, resendConversionPopupAutoTrashId,
		error
	} = props;
	const submit = handleSubmit(formData => resendAutotrashConversion(
		{ ...autotrashDataToResend.payload, ...formData }, resendConversionPopupAutoTrashId
	));

	return (
		<form
			className="payouts-transaction-form-wrap display-flex flex-column"
			onSubmit={submit}
		>
			<div className="break-word">
				<b>Autotrash conversion data:</b>
				<p>{ JSON.stringify(autotrashDataToResend) }</p>
			</div>
			{
				error && <div className="ui-form__element margin-top-20 error-text"> {error} </div>
			}
			{
				autotrashDataToResend.resend_conversion_id &&
				<div className="ui-form__element margin-top-20">
					Already resent linked conversion id: { autotrashDataToResend.resend_conversion_id }
				</div>
			}
			<div className="ui-form__element margin-top-20">
				<Field
					name="country_code"
					placeholder="New country_code"
					component={InputField}
					showLabel={true} />
			</div>
			<div className="ui-form__element margin-top-20">
				<Field
					name="phone"
					placeholder="New phone"
					component={InputField}
					showLabel={true} />
			</div>
			<div className="ui-form__element margin-top-20">
				<Field
					name="user_language"
					placeholder="Language"
					component={InputField}
					showLabel={true} />
			</div>
			<div className="ui-form__element buttons-wrap margin-top-20">
				<button className="ui-btn ui-btn-primary">Send</button>
			</div>
		</form>
	);
};

Form.propTypes = {
	intl: PropTypes.func
};

const Main = props =>
	<ModalBox
		title={props.intl(`Переотправить автотреш лид`)}
		body={Form(props)}
		isOpen={!!props.resendConversionPopupAutoTrashId}
		onClose={props.toggleResendPopup}
		className="resend-form-modal"
	/>;

Main.propTypes = {
	intl: PropTypes.func
};

export default reduxForm({
	form: 'resendAutoTrashForm',
	enableReinitialize: true
})(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/components/popups/resend-conversion.js